import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  FaTrashAlt,
  FaFileExport,
  FaAngleDoubleRight,
  FaEye,
  FaVoteYea,
} from "react-icons/fa";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { API_URL } from "../../../../api/api";

export default function TreatmentDeferDialog(props) {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [defferAmount, setDefferAmount] = useState("");
  // console.log(props.data.medicineItems[0].item_id, 'props')
  const [date, setDate] = useState("");
  const [all, setAll] = useState([]);
  const [firstAccount, setFirstAccount] = useState([]);
  const [secAccount, setSecAccount] = useState([]);
  const [relatedPatient, setRelatedPatient] = useState([]);

  const allItems = props.data && [
    ...all,
    ...props.data?.relatedMedicineItemsIssueToClinic,
    ...props.data.relatedProcedureItemsIssueToClinic,
    ...props.data.relatedAccessoryItemsIssueToClinic,
  ];
  // console.log(props.data?.medicineItems, 'all')

  //setting up for data
  // setAll([...all, props.data?.medicineItems])
  // console.log(allItems, 'sfsdjfaskl')
  useEffect(() => {
    // const list = [...allItems]

    const getAccountingLists = async () => {
      const res = await api.get("accounting-lists");
      const FirAcc = res.data.list.filter(
        (e) => e.name === "Deferred Treatment Sale",
      );
      setFirstAccount(FirAcc);
      const SecAcc = res.data.list.filter((e) => e.name === "Treatment Sale");
      setSecAccount(SecAcc);
    };

    const getPatientTreatment = async () => {
      const res = await api.get("patient-treatments");

      setRelatedPatient(res.data.list);
    };

    // getBankLists();

    getAccountingLists();
    getPatientTreatment();
  }, []);

  const _export1 = React.useRef(null);
  const exportBtnHandler = () => {
    if (_export1.current !== null) {
      _export1.current.props.data
        .filter((el) => el.relatedMedicineItemsIssueToClinic)
        .map(function (element, index) {
          // element.code = element.item_id.code
          element.mcode = element.code;
          element.mname = element.medicineItemName;
          element.mqty = props.data?.removeQty;
        });
      _export1.current.props.data
        .filter((el) => el.relatedProcedureItemsIssueToClinic)
        .map(function (element, index) {
          // element.code = element.item_id.code
          element.pcode = element.code;
          element.pname = element.procedureItemName;
          element.pqty = props.data?.removeQty;
        });
      _export1.current.props.data
        .filter((el) => el.relatedAccessoryItemsIssueToClinic)
        .map(function (element, index) {
          // element.code = element.item_id.code
          element.acode = element.code;
          element.aname = element.accessoryItemName;
          element.aqty = props.data?.removeQty;
        });

      _export1.current.save();
    }
  };
  return (
    <div>
      <Dialog open={props.open} onClose={props.close} fullWidth maxWidth="lg">
        <DialogTitle>
          {" "}
          <div className="modal-header bg-info">
            <h2 className="modal-title">Detail</h2>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.close}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Medicine */}
            {props.data && props.data.relatedMedicineItemsIssueToClinic[0] && (
              <div>
                <h5 className="text-decoration-underline">Medicine</h5>
                <div>
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Code</th>
                        <th>Item Name</th>
                        <th>Transfer Qty</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: "16px", fontWeight: "10px" }}>
                      {props.data &&
                        props.data.relatedMedicineItemsIssueToClinic.map(
                          (item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item?.code}</td>
                              <td>{item?.medicineItemName}</td>

                              <td>{props.data?.removeQty}</td>
                            </tr>
                          ),
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Pro Med */}
            {props.data && props.data.relatedProcedureItemsIssueToClinic[0] && (
              <div>
                <h5 className="text-decoration-underline">
                  Procedure Medicine
                </h5>
                <div>
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Code</th>
                        <th>Item Name</th>
                        <th>Transfer Qty</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: "16px", fontWeight: "10px" }}>
                      {props.data &&
                        props.data.relatedProcedureItemsIssueToClinic.map(
                          (item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item?.code}</td>
                              <td>{item?.procedureItemName}</td>

                              <td>{props.data?.removeQty}</td>
                            </tr>
                          ),
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Pro Ass */}
            {props.data && props.data.relatedAccessoryItemsIssueToClinic[0] && (
              <div>
                <h5 className="text-decoration-underline">
                  Procedure Accessory
                </h5>
                <div>
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Code</th>
                        <th>Item Name</th>
                        <th>Transfer Qty</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: "16px", fontWeight: "10px" }}>
                      {props.data &&
                        props.data.relatedAccessoryItemsIssueToClinic.map(
                          (item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item?.code}</td>
                              <td>{item?.accessoryItemName}</td>

                              <td>{props.data?.removeQty}</td>
                            </tr>
                          ),
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="text-center py-3">
              {/* <button onClick={exportBtnHandler} className='btn btn-sm btn-success '>Export to Excel</button> */}
              <ExcelExport
                data={allItems}
                ref={_export1}
                fileName={`${props.data.code}-${props.data.date?.split("T")[0]}`}
              >
                <ExcelExportColumn
                  field=""
                  title="No"
                  locked={true}
                  width={30}
                />

                {/* <ExcelExportColumn
                                    field='mcode'
                                    title='Code'
                                    headerCellOptions={{
                                        textAlign: 'center'
                                    }}
                                    width={250}
                                /> */}

                <ExcelExportColumn
                  // field='item_id.medicineItemName'

                  title="Medicine"
                  headerCellOptions={{
                    textAlign: "center",
                    fontSize: 20,
                  }}
                  width={250}
                  height={60}
                >
                  <ExcelExportColumn
                    field="mcode"
                    title="Code"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>

                  <ExcelExportColumn
                    field="mname"
                    title="Medicine Item Name"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>
                  <ExcelExportColumn
                    field="mqty"
                    title="Quantity"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>
                </ExcelExportColumn>

                <ExcelExportColumn
                  // field='item_id.medicineItemName'
                  title="Procedure"
                  headerCellOptions={{
                    textAlign: "center",
                    fontSize: 20,
                  }}
                  width={250}
                >
                  <ExcelExportColumn
                    field="pcode"
                    title="Code"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>

                  <ExcelExportColumn
                    field="pname"
                    title="Procedure Item Name"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>
                  <ExcelExportColumn
                    field="pqty"
                    title="Quantity"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>
                </ExcelExportColumn>

                <ExcelExportColumn
                  // field='item_id.medicineItemName'
                  title="Accessory List"
                  headerCellOptions={{
                    textAlign: "center",
                    fontSize: 20,
                  }}
                  width={250}
                >
                  <ExcelExportColumn
                    field="acode"
                    title="Code"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>

                  <ExcelExportColumn
                    field="aname"
                    title="Accessory Item Name"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={350}
                  ></ExcelExportColumn>
                  <ExcelExportColumn
                    field="aqty"
                    title="Quantity"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>
                </ExcelExportColumn>

                <ExcelExportColumn
                  // field='item_id.medicineItemName'
                  title="General List"
                  headerCellOptions={{
                    textAlign: "center",
                    fontSize: 20,
                  }}
                  width={250}
                >
                  <ExcelExportColumn
                    field="gcode"
                    title="Code"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>

                  <ExcelExportColumn
                    field="gname"
                    title="General Item Name"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    width={350}
                  ></ExcelExportColumn>
                  <ExcelExportColumn
                    field="gqty"
                    title="Quantity"
                    headerCellOptions={{
                      textAlign: "center",
                    }}
                    cellOptions={{
                      textAlign: "center",
                    }}
                    width={250}
                  ></ExcelExportColumn>
                </ExcelExportColumn>
              </ExcelExport>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
